<script setup>
import { ref, computed } from "vue";

const sections = [
  { id: "hero", label: "Sekcja główna firmy", price: 0 },
  { id: "nav", label: "Nawigacja / Menu", price: 0 },
  { id: "footer", label: "Stopka", price: 0 },
  { id: "about", label: "O nas", price: 200 },
  { id: "services", label: "Usługi / Oferta / Produkty", price: 400 },
  { id: "pricing", label: "Cennik", price: 300 },
  { id: "portfolio", label: "Realizacje / Portfolio", price: 400 },
  { id: "faq", label: "FAQ – pytania i odpowiedzi", price: 200 },
  { id: "clients", label: "Lista klientów / partnerów", price: 200 },
  { id: "contact_form", label: "Formularz kontaktowy", price: 400 },
  { id: "team", label: "Zespół", price: 200 },
  { id: "gallery", label: "Interaktywna galeria", price: 300 },
  { id: "hours", label: "Godziny otwarcia", price: 100 },
  { id: "contact_details", label: "Dane kontaktowe", price: 100 },
  { id: "map", label: "Mapa jak dojechać Google", price: 100 },
  { id: "reviews", label: "Opinie klientów z Google", price: 400 },
];

const selectedIds = ref([]);

const selectedItems = computed(() =>
  sections.filter((s) => selectedIds.value.includes(s.id))
);
const price = computed(() => selectedItems.value.reduce((sum, s) => sum + s.price, 0));

defineExpose({
  selectedIds,
  selectedItems,
  price,
});
</script>

<template>
  <article>
    <header class="mb-3">
      <h2 class="text-2xl font-semibold tracking-tight text-slate-900">
        Wybierz, co powinno znaleźć się na Twojej stronie
      </h2>
      <p class="mt-1.5 text-slate-600">
        Twoja strona to nie szablon – to narzędzie do komunikacji. Każda sekcja ma swoją
        rolę: jedne budują zaufanie, inne sprzedają, jeszcze inne informują. Ty
        decydujesz, co jest Ci potrzebne.
      </p>
    </header>

    <div
      class="mb-5 rounded-xl border border-slate-200 bg-slate-50 p-3 text-[15px] text-slate-700"
    >
      <strong>Nie wiesz, co wybrać?</strong> Spokojnie — jeśli zostawisz coś pustego,
      doradzimy Ci podczas planowania strony.
    </div>

    <!-- Lista kompaktowa: jedna pozycja w wierszu -->
    <div
      role="group"
      aria-label="Wybór sekcji"
      class="grid grid-cols-1 md:grid-cols-2 gap-3"
    >
      <label
        v-for="s in sections"
        :key="s.id"
        class="cursor-pointer group relative flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition hover:shadow-md"
        :class="selectedIds.includes(s.id) ? 'ring-2 ring-slate-900 bg-slate-50' : ''"
        @click="
          selectedIds.includes(s.id)
            ? (selectedIds = selectedIds.filter((id) => id !== s.id))
            : selectedIds.push(s.id)
        "
      >
        <!-- Ikona -->
        <div
          class="grid w-9 aspect-square place-items-center rounded-lg bg-gradient-to-br from-slate-900 to-slate-700 text-white shadow"
        >
          🧩
        </div>

        <!-- Tytuł -->
        <div class="min-w-0 flex-1">
          <h3 class="text-[15px] font-semibold text-slate-900">
            {{ s.label }}
          </h3>
        </div>

        <!-- Cena -->
        <div class="ml-2 flex items-baseline gap-1">
          <span class="text-xl font-semibold text-slate-900">{{ s.price }}</span>
          <span class="text-xs text-slate-500">zł</span>
        </div>
      </label>
    </div>
  </article>
</template>
